import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

import { theme } from "@/src/theme/theme";

type Sx = SystemStyleObject<Theme>;

export const containerSx: Sx = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  border: 1,
  borderColor: theme.palette.divider,
  borderRadius: 1,
  overflow: "hidden",
  backgroundColor: theme.palette.background.paper
};

export const toolbarSx: Sx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
  p: 1,
  borderBottom: 1,
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper
};

export const scrollContainerSx: Sx = {
  flex: 1,
  overflow: "auto",
  position: "relative"
};

export const tableSx: Sx = {
  borderCollapse: "separate",
  borderSpacing: 0,
  width: "100%",
  tableLayout: "fixed"
};

export const headerRowSx: Sx = {
  backgroundColor: theme.palette.background.paper
};

export const headerCellBaseSx: Sx = {
  px: 0.75,
  py: 1,
  textAlign: "left",
  borderBottom: 1,
  borderColor: theme.palette.divider,
  fontSize: (theme) => theme.typography.buttonSmall.fontSize,
  fontWeight: theme.typography.fontWeightSemibold,
  userSelect: "none",
  backgroundColor: theme.palette.background.paper,
  position: "sticky",
  top: 0,
  zIndex: 3
};

export const filterRowSx: Sx = {
  backgroundColor: theme.palette.background.paper
};

export const filterCellSx: Sx = {
  px: 0.5,
  py: 0.5,
  borderBottom: 1,
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
  position: "sticky",
  zIndex: 2
};

export const bodyCellBaseSx: Sx = {
  px: 0.75,
  borderBottom: 1,
  borderColor: theme.palette.divider,
  fontSize: (theme) => theme.typography.buttonSmall.fontSize,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  backgroundColor: theme.palette.background.paper,
  verticalAlign: "middle"
};

export const actionsCellSx: Sx = {
  overflow: "visible",
  whiteSpace: "nowrap",
  textAlign: "right",
  px: 0.5
};

export const resizeHandleSx: Sx = {
  position: "absolute",
  right: 0,
  top: 0,
  height: "100%",
  width: "4px",
  cursor: "col-resize",
  userSelect: "none",
  touchAction: "none",
  "&:hover": {
    backgroundColor: theme.palette.semantic.primary.light
  }
};

export const sortIconSx: Sx = {
  fontSize: (theme) => theme.typography.body1.fontSize,
  verticalAlign: "middle",
  ml: 0.5
};

export const emptyStateSx: Sx = {
  p: 4,
  textAlign: "center",
  color: theme.palette.text.secondary
};

export const statusBarSx: Sx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  px: 1.5,
  py: 0.75,
  borderTop: 1,
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  fontSize: (theme) => theme.typography.caption.fontSize
};

export const loadingOverlaySx: Sx = {
  position: "absolute",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.5,
  zIndex: 5
};
